import { useDialog } from '@globals/dialog/useDialogStore'
import { Recognition } from '@kudos/http-client'

export enum MobileRecognitionDrawerView {
  DRAFT_AND_SCHEDULED = 'DraftAndScheduled',
  RECIPIENTS = 'Recipients',
  QUALITIES = 'QualityOptions',
  VISIBILITY = 'Visibility',
  POINTS = 'Points',
  SCHEDULE = 'Schedule',
  POINTS_EXCEPTION = 'PointsException',
}

export type MobileRecognitionDrawerData = {
  view: MobileRecognitionDrawerView
  recognition?: Recognition
}

export const MOBILE_RECOGNITION_DRAWER_KEY = 'mobileRecognitionDrawerKey'

const useMobileRecognitionDrawer = () => {
  const {
    setData,
    openDialog: open,
    closeDialog: close,
    isOpen,
    dialogData,
  } = useDialog<MobileRecognitionDrawerData>(MOBILE_RECOGNITION_DRAWER_KEY)

  return {
    setView: (
      view: MobileRecognitionDrawerView,
      data?: Partial<Omit<MobileRecognitionDrawerData, 'view'>>,
    ) => {
      setData({ ...(dialogData ?? {}), view, ...data })
    },
    openDrawer: (data?: Partial<MobileRecognitionDrawerData>) => {
      open({
        view: data?.view ?? MobileRecognitionDrawerView.DRAFT_AND_SCHEDULED,
        recognition: data?.recognition,
      })
    },
    closeDrawer: () => {
      close()
    },
    isOpen,
    dialogData,
  }
}

export default useMobileRecognitionDrawer
